import { WheelOperationDto, WheelOperationReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type WheelOperationDtoAny = WheelOperationDto | WheelOperationReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type WheelOperationDtoAll = WheelOperationDto & WheelOperationReferenceDto;

export class WheelOperationMapper {}
